import { useState, useRef } from "react";
import { MoveHorizontal } from "lucide-react";

export const BeforeAfterSlider = ({ before, after }) => {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const move = (clientX) => {
    const rect = containerRef.current.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  };

  const onDown = () => (dragging.current = true);
  const onUp = () => (dragging.current = false);
  const onMove = (e) => {
    if (!dragging.current) return;
    move(e.clientX);
  };
  const onTouchMove = (e) => move(e.touches[0].clientX);

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className="relative w-full aspect-square overflow-hidden select-none cursor-ew-resize rounded-lg border border-white/10 bg-black"
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchMove={onTouchMove}
    >
      <img src={after} alt="Na" className="absolute inset-0 w-full h-full object-contain" draggable={false} />
      <span className="absolute bottom-5 right-5 z-10 bg-black/70 text-white text-xs px-3 py-1.5 tracking-widest uppercase">Na</span>

      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img src={before} alt="Voor" className="absolute inset-0 h-full object-contain max-w-none" style={{ width: containerRef.current ? containerRef.current.offsetWidth : "100vw" }} draggable={false} />
        <span className="absolute bottom-5 left-5 z-10 bg-[#FF1A1A] text-white text-xs px-3 py-1.5 tracking-widest uppercase">Voor</span>
      </div>

      <div className="absolute top-0 bottom-0 z-20" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
        <div className="w-[2px] h-full bg-white" />
        <button
          onMouseDown={onDown}
          onTouchStart={onDown}
          data-testid="slider-handle"
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 rounded-full bg-white flex items-center justify-center shadow-xl cursor-ew-resize"
        >
          <MoveHorizontal size={22} className="text-black" />
        </button>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;
